import { Injectable } from "@angular/core";
import { Observable, Observer } from 'rxjs';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ComunicacaoService } from "./comunicacao.service";
import { environment } from "src/environments/environment";
import * as CryptoJS from 'crypto-js';

//Conexão com o WebScoket do orçamento em questão

export interface Message {
  source: string;
  content: any;
}
@Injectable({
  providedIn: 'root'
})
export class WebSocketChatService {
  private subject: AnonymousSubject<MessageEvent>;
  public messages: Subject<any>;
  isReconecting: boolean = false;
  isConnected: boolean = false;
  protected dev: boolean = !environment.production;

  //chave mestre, essa chave é a usada para criptografia das novas chaves cripto que poderam ser enviadas no WebSocket, em caso de muitas quebras de segurança
  //aconselho que a chave abaixo seja trocada para manter a segurança do sistema, lembrando que essa troca só valera se a função "protectChaveCryptografia"
  //tiver sido implementada, caso contrário não ira adiantar essa troca
  protected chavePai: string = '01000100011001010111001101100101011011100111011001101111011011000111011001101001011001000110111100100000011100000110111101110010001000000100100101110100011000010110110001101111';
  public connectionStats: Subject<boolean>;
  private chaveCrypto: string;
  public chave: Subject<string>;
  constructor(
    private comu: ComunicacaoService
  ) {
    this.connectionStats = new Subject();
    this.chave = new Subject();
    this.chave.subscribe((key: string) => {
      if (key)
        this.chaveCrypto = key
    });
  }

  webSocketReconnect(url) {
    this.isReconecting = true;
    this.subject = null;
    this.webSocketConnect(url);
  }

  webSocketConnect(url) {
    //caso a url venha com o ws o wss é inserido no lugar
    //essa alteração viza a segurança, pois o protocolo ws se assimila ao http e o wss ao https
    if (!this.dev)
      url = String(url).replace('ws:', 'wss:')
    try {
      this.messages = <Subject<Message>>this.connect(url).pipe(
        map(
          (response: MessageEvent): Message => {
            try {
              let data = JSON.parse(this.descriptografarMensagem(response.data));
              if (data?.code == 1) {
                let teste = this.protectChaveCryptografia(data?.content?.new, data?.content?.old);
              }
              return data;
            } catch { return null; }
          }
        )
      );
      this.connectionStats.next(true);
      this.isConnected = true;
    } catch (e) { this.connectionStats.next(false); this.isConnected = false; }
  }

  public connect(url): AnonymousSubject<MessageEvent> {
    if (!this.subject) {
      this.subject = this.create(url);
      if (this.dev)
        console.log("Successfully connected-chat: " + url);
      if (!this.isReconecting) this.comu.filter('connected-chat');
      else this.comu.filter('re-connected-chat');
    }
    return this.subject;
  }

  private create(url): AnonymousSubject<MessageEvent> {
    let ws = new WebSocket(url);
    let observable = new Observable((obs: Observer<MessageEvent>) => {
      ws.onmessage = obs.next.bind(obs);
      ws.onerror = obs.error.bind(obs);
      ws.onclose = (event) => {
        this.connectionStats.next(false);
        this.isConnected = false;
        this.comu.filter('reconnect-chat');
      };
      return ws.close.bind(ws);
    });
    let observer = {
      error: null,
      complete: () => {
        this.isConnected = false;
      },
      next: (data: Object) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(this.criptografarMensagem(JSON.stringify(data)));
        }
      }
    };
    return new AnonymousSubject<MessageEvent>(observer, observable);
  }

  disconect() {
    this.subject.complete();
    this.messages.complete();
  }


  criptografarMensagem(value: string) {
    return CryptoJS.AES.encrypt(value, this.chaveCrypto).toString();
  }

  descriptografarMensagem(value: string) {
    try { return CryptoJS.AES.decrypt(value, String(this.chaveCrypto)).toString(CryptoJS.enc.Utf8); } catch { return null; }
  }

  descriptografarNovaChave(value: string) {
    try { return CryptoJS.AES.decrypt(value, String(this.chavePai)).toString(CryptoJS.enc.Utf8); } catch { return null; }
  }

  //essa função ainda não foi implementada, mas sua criação foi feita com o intuito de manter a segurança do sistema, trocando a chave da criptografia sempre que
  //ocorre uma quebra de segurança no WebSocket, sempre que é criada uma nova chave no back ele envia usando um padrão pre-definido,
  //se esse padrão for quebrado uma nova chave é gerada para todos os clients, fazendo com que a segurança seja mantida
  protectChaveCryptografia(newKey: string, oldKey: string) {
    //para cada alteraçao de chave que entra aqui, foi solicitada pelo próprio WebSocket, diferente das outras requisições essa é criptografada com a chave antiga e a nova chave
    //é criptografada usando a chavePai, visando a segurança toda vez que a chave de criptografia é cunsultada ela é criptografada com a chavePai essa chave
    //protege a nova chave para evitar problemas de segurança, assim mesmo que uma chave seja descoberta uma nova será gerada, o que ira retornar o sistema à segurança
    //newKey = this.descriptografarNovaChave(newKey);
    if (!oldKey || !newKey) {
      return false
    };
    if (this.chaveCrypto == oldKey && this.chaveCrypto != newKey) {
      this.chaveCrypto = newKey;
      return true;
    }
    return false
  }
}